import {
  SupplierInquiryWithQuotationVO,
  QuotationItemDTO,
  QuotationItemCountVO,
} from '@/api/inquiry'
import { PaginationOption, TableRes } from '@/global'
import { fileFile } from '@/modules/uploadfiles/hooks'
import { RcFile } from 'antd/lib/upload'
export type InquiryQuotationListItem = SupplierInquiryWithQuotationVO
interface State {
  formData: any
  detailInfo?: SupplierInquiryWithQuotationVO
  isLoading: boolean
  hideClientInfo?: boolean
  importModalOpen: boolean
  importUploadList: fileFile[]
  importOriginFile?: RcFile
  importConfirmLoading: boolean
  quotationItemCount?: QuotationItemCountVO
  quotationItemsPage?: QuotationItemDTO[]
  currentTabKey?: 'all' | 'quoted' | 'unquoted'
  quotationPageOption?: PaginationOption
  editModalOpen: boolean
  editTabIndex?: number
}
type ActionType = CustomActionTypes<State>

interface Action {
  type: ActionType
  payload: any
}

export const initialState: State = {
  formData: {},
  detailInfo: undefined,
  isLoading: false,
  hideClientInfo: false,
  importModalOpen: false,
  importUploadList: [],
  importOriginFile: undefined,
  importConfirmLoading: false,
  quotationItemCount: undefined,
  quotationItemsPage: undefined,
  currentTabKey: 'all',
  quotationPageOption: { pageNo: 1, pageSize: 100000, totalCount: 0 },
  editModalOpen: false,
  editTabIndex: undefined,
}

export function reducer(state: State = initialState, action: Action): State {
  const newstate = { ...state }
  switch (action.type) {
    case 'setFormDataAction':
      newstate.formData = action.payload
      return newstate
    case 'setDetailInfoAction':
      newstate.detailInfo = action.payload
      return newstate
    case 'setIsLoadingAction':
      newstate.isLoading = action.payload
      return newstate
    case 'setHideClientInfoAction':
      newstate.hideClientInfo = action.payload
      return newstate
    case 'setImportModalOpenAction':
      newstate.importModalOpen = action.payload
      return newstate
    case 'setImportUploadListAction':
      newstate.importUploadList = action.payload
      return newstate
    case 'setImportOriginFileAction':
      newstate.importOriginFile = action.payload
      return newstate
    case 'setImportConfirmLoadingAction':
      newstate.importConfirmLoading = action.payload
      return newstate
    case 'setQuotationItemCountAction':
      newstate.quotationItemCount = action.payload
      return newstate
    case 'setQuotationItemsPageAction':
      newstate.quotationItemsPage = action.payload
      return newstate
    case 'setQuotationPageOptionAction':
      newstate.quotationPageOption = action.payload
      return newstate
    case 'setCurrentTabKeyAction':
      newstate.currentTabKey = action.payload
      return newstate
    case 'setEditModalOpenAction':
      newstate.editModalOpen = action.payload
      return newstate
    case 'setEditTabIndexAction':
      newstate.editTabIndex = action.payload
      return newstate
    case 'resetStateAction':
      return initialState
    default:
      throw new Error('no match actions')
  }
}

export const setHideClientInfoAction = (val: boolean): Action => ({
  type: 'setHideClientInfoAction',
  payload: val,
})

export const setIsLoadingAction = (val: boolean): Action => ({
  type: 'setIsLoadingAction',
  payload: val,
})

/**
 * 设置详情信息
 * @param val
 * @returns
 */
export const setDetailInfoAction = (
  val: SupplierInquiryWithQuotationVO,
): Action => ({
  type: 'setDetailInfoAction',
  payload: val,
})
/**
 * 重置redux内容，关闭页面时调用
 * @returns
 */
export const resetStateAction = (): Action => ({
  type: 'resetStateAction',
  payload: undefined,
})

/**
 * 保存表单数据
 * @param val
 * @returns
 */
export const setFormDataAction = (val: any): Action => ({
  type: 'setFormDataAction',
  payload: val,
})

export const setImportModalOpenAction = (open: boolean): Action => ({
  type: 'setImportModalOpenAction',
  payload: open,
})

export const setImportUploadListAction = (list: fileFile[]): Action => ({
  type: 'setImportUploadListAction',
  payload: list,
})

export const setImportOriginFileAction = (file?: RcFile): Action => ({
  type: 'setImportOriginFileAction',
  payload: file,
})

export const setImportConfirmLoadingAction = (loading: boolean): Action => ({
  type: 'setImportConfirmLoadingAction',
  payload: loading,
})

export const setQuotationItemCountAction = (
  val: QuotationItemCountVO,
): Action => ({
  type: 'setQuotationItemCountAction',
  payload: val,
})

export const setQuotationItemsPageAction = (
  val: QuotationItemDTO[],
): Action => ({
  type: 'setQuotationItemsPageAction',
  payload: val,
})

export const setCurrentTabKeyAction = (
  key: 'all' | 'quoted' | 'unquoted',
): Action => ({
  type: 'setCurrentTabKeyAction',
  payload: key,
})

export const setQuotationPageOptionAction = (
  val: PaginationOption,
): Action => ({
  type: 'setQuotationPageOptionAction',
  payload: val,
})

export const setEditModalOpenAction = (open: boolean): Action => ({
  type: 'setEditModalOpenAction',
  payload: open,
})

export const setEditTabIndexAction = (index?: number): Action => ({
  type: 'setEditTabIndexAction',
  payload: index,
})
import {
  SupplierInquiryWithQuotationVO,
  QuotationItemDTO,
  QuotationItemCountVO,
} from '@/api/inquiry'
import { PaginationOption, TableRes } from '@/global'
import { fileFile } from '@/modules/uploadfiles/hooks'
import { RcFile } from 'antd/lib/upload'
export type InquiryQuotationListItem = SupplierInquiryWithQuotationVO
interface State {
  formData: any
  detailInfo?: SupplierInquiryWithQuotationVO
  isLoading: boolean
  hideClientInfo?: boolean
  importModalOpen: boolean
  importUploadList: fileFile[]
  importOriginFile?: RcFile
  importConfirmLoading: boolean
  quotationItemCount?: QuotationItemCountVO
  quotationItemsPage?: QuotationItemDTO[]
  currentTabKey?: 'all' | 'quoted' | 'unquoted'
  quotationPageOption?: PaginationOption
  editModalOpen: boolean
  editTabIndex?: number
}
type ActionType = CustomActionTypes<State>

interface Action {
  type: ActionType
  payload: any
}

export const initialState: State = {
  formData: {},
  detailInfo: undefined,
  isLoading: false,
  hideClientInfo: false,
  importModalOpen: false,
  importUploadList: [],
  importOriginFile: undefined,
  importConfirmLoading: false,
  quotationItemCount: undefined,
  quotationItemsPage: undefined,
  currentTabKey: 'all',
  quotationPageOption: { pageNo: 1, pageSize: 100000, totalCount: 0 },
  editModalOpen: false,
  editTabIndex: undefined,
}

export function reducer(state: State = initialState, action: Action): State {
  const newstate = { ...state }
  switch (action.type) {
    case 'setFormDataAction':
      newstate.formData = action.payload
      return newstate
    case 'setDetailInfoAction':
      newstate.detailInfo = action.payload
      return newstate
    case 'setIsLoadingAction':
      newstate.isLoading = action.payload
      return newstate
    case 'setHideClientInfoAction':
      newstate.hideClientInfo = action.payload
      return newstate
    case 'setImportModalOpenAction':
      newstate.importModalOpen = action.payload
      return newstate
    case 'setImportUploadListAction':
      newstate.importUploadList = action.payload
      return newstate
    case 'setImportOriginFileAction':
      newstate.importOriginFile = action.payload
      return newstate
    case 'setImportConfirmLoadingAction':
      newstate.importConfirmLoading = action.payload
      return newstate
    case 'setQuotationItemCountAction':
      newstate.quotationItemCount = action.payload
      return newstate
    case 'setQuotationItemsPageAction':
      newstate.quotationItemsPage = action.payload
      return newstate
    case 'setQuotationPageOptionAction':
      newstate.quotationPageOption = action.payload
      return newstate
    case 'setCurrentTabKeyAction':
      newstate.currentTabKey = action.payload
      return newstate
    case 'setEditModalOpenAction':
      newstate.editModalOpen = action.payload
      return newstate
    case 'setEditTabIndexAction':
      newstate.editTabIndex = action.payload
      return newstate
    case 'resetStateAction':
      return initialState
    default:
      throw new Error('no match actions')
  }
}

export const setHideClientInfoAction = (val: boolean): Action => ({
  type: 'setHideClientInfoAction',
  payload: val,
})

export const setIsLoadingAction = (val: boolean): Action => ({
  type: 'setIsLoadingAction',
  payload: val,
})

/**
 * 设置详情信息
 * @param val
 * @returns
 */
export const setDetailInfoAction = (
  val: SupplierInquiryWithQuotationVO,
): Action => ({
  type: 'setDetailInfoAction',
  payload: val,
})
/**
 * 重置redux内容，关闭页面时调用
 * @returns
 */
export const resetStateAction = (): Action => ({
  type: 'resetStateAction',
  payload: undefined,
})

/**
 * 保存表单数据
 * @param val
 * @returns
 */
export const setFormDataAction = (val: any): Action => ({
  type: 'setFormDataAction',
  payload: val,
})

export const setImportModalOpenAction = (open: boolean): Action => ({
  type: 'setImportModalOpenAction',
  payload: open,
})

export const setImportUploadListAction = (list: fileFile[]): Action => ({
  type: 'setImportUploadListAction',
  payload: list,
})

export const setImportOriginFileAction = (file?: RcFile): Action => ({
  type: 'setImportOriginFileAction',
  payload: file,
})

export const setImportConfirmLoadingAction = (loading: boolean): Action => ({
  type: 'setImportConfirmLoadingAction',
  payload: loading,
})

export const setQuotationItemCountAction = (
  val: QuotationItemCountVO,
): Action => ({
  type: 'setQuotationItemCountAction',
  payload: val,
})

export const setQuotationItemsPageAction = (
  val: QuotationItemDTO[],
): Action => ({
  type: 'setQuotationItemsPageAction',
  payload: val,
})

export const setCurrentTabKeyAction = (
  key: 'all' | 'quoted' | 'unquoted',
): Action => ({
  type: 'setCurrentTabKeyAction',
  payload: key,
})

export const setQuotationPageOptionAction = (
  val: PaginationOption,
): Action => ({
  type: 'setQuotationPageOptionAction',
  payload: val,
})

export const setEditModalOpenAction = (open: boolean): Action => ({
  type: 'setEditModalOpenAction',
  payload: open,
})

export const setEditTabIndexAction = (index?: number): Action => ({
  type: 'setEditTabIndexAction',
  payload: index,
})
